import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/libraries`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/libraries`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/libraries/create`, parameters)
    },

    delete (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/libraries/delete`, parameters)
    },

    restore (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/libraries/restore`, parameters)
    },

    assign (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/libraries/assign`, parameters)
    }
}
